import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

function Renewable() {
  return (
    <section className="service-detail">

      {/* 🔥 HERO BANNER */}
        <section className="hero-banner">
          <img src="/service/RenewableEnergy.jpeg" alt="" />

          <div className="hero-content">
            <h1>RENEWABLE ENERGY</h1>
            {/* <p>Swastika Infra Limited</p>   */}
          </div>
        </section>


      {/* 📄 CONTENT SECTION */}
        <div className="service-detail-content">

          <h2 className="service-heading">RENEWABLE ENERGY</h2>

          <p>
           Advanced renewable energy solutions enable efficient, sustainable power generation through solar power projects, solar EPC, and integrated power evacuation infrastructure. Engineered with modern technologies and robust systems, these solutions support reliable grid integration, optimize energy transmission, and contribute to reducing dependence on conventional power sources. Designed to meet growing energy demands, they strengthen clean energy infrastructure while supporting a sustainable and future-ready power network.
          </p>

         

         

          {/* <h3 className="highlight-title">Key Highlights:</h3>

          <ul className="highlight-list">
            <li>Redevelopment of high-traffic railway stations</li>
            <li>Construction and upgrading of tracks and rail infrastructure</li>
            <li>Integration of advanced technologies for faster execution</li>
            <li>Alignment with modernization and smart mobility goals</li>
          </ul> */}


              <Link to="/service" className="back-btn">
                ← Back 
              </Link> 
        </div>

    </section>
  );
}


export default Renewable;
